import { Typography, Box } from '@mui/material';

interface IExperienceLevelProps {
    background: string;
    title: string;
    shortForm: string;
}

const ExperienceLevel = (props: IExperienceLevelProps) => {
    return (
        <Box>
            <Box
                sx={{
                    color: '#FFFFFF',
                    background: props.background,
                    borderRadius: '6px',
                    padding: '4px 8px',
                    display: 'flex',
                    gap: '8px',
                    alignItems: 'center'
                }}
            >
                <Typography
                    sx={{
                        // maxWidth: '150px',
                        // overflow: 'hidden',
                        whiteSpace: 'nowrap',
                        textOverflow: 'ellipsis',
                        fontSize: { xs: '12px' },
                        fontWeight: '600',
                        fontFamily: 'Open Sans'
                    }}
                >
                    {props.title}
                </Typography>
                <Typography
                    sx={{
                        fontWeight: '700',
                        background: 'rgba(5, 5, 5, 0.4)',
                        padding: '1px 4px',
                        lineHeight: '14px',
                        borderRadius: '4px'
                    }}
                >
                    {props.shortForm}
                </Typography>
            </Box>
        </Box>
    );
};

export default ExperienceLevel;
